import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import React from "react";
import baseUrl from "../../API/BaseUrl";


const initialState = {
    addProductToCart: [],
    getAllCartItems: [],
    deleteAllCartItems: [],
    deleteOneCartItem: [],
    updateCartData: [],
    applyCoupon: [],
    isLoading: true,
    isSuccess: true,
    errorMessage: "",
}


// add product to cart
export const AddProductToCart = createAsyncThunk("cart/AddProduct", async (body) => {
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            },
        }
        const res = await baseUrl.post("/api/v1/cart", body, config)
        return res
    } catch (error) {
        return error
    }
})

// get all cart items
export const GetAllCartItems = createAsyncThunk("cart/getAll", async () => {
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            },
        }
        const res = await baseUrl.get("/api/v1/cart", config)
        return res
    } catch (error) {
        return error
    }
})

// delete all cart items
export const DeleteAllItemsCart = createAsyncThunk("cart/deleteAll", async () => {
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            },
        }
        const res = await baseUrl.delete("/api/v1/cart", config)
        return res
    } catch (error) {
        return error
    }
})

// delete one cart item
export const DeleteOneItemCart = createAsyncThunk("cart/deleteOne", async (id) => {
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            },
        }
        const res = await baseUrl.delete(`/api/v1/cart/${id}`, config)
        return res
    } catch (error) {
        return error
    }
})

// update one cart item
export const UpdateCartItem = createAsyncThunk("cart/updateOne", async ({id,data }) => {
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            },
        }
        const res = await baseUrl.put(`/api/v1/cart/${id}`,data, config)
        return res
    } catch (error) {
        return error
    }
})

// apply coupon
export const ApplyCoupon = createAsyncThunk("cart/applyCoupon", async (data) => {
    try {
        const config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            },
        }
        const res = await baseUrl.put("/api/v1/cart/applyCoupon", data, config)
        return res
    } catch (error) {
        return error
    }
})


const CartSlice = createSlice({
    name: "Cart",
    initialState,
    reducers: {},
    extraReducers: {
        [AddProductToCart.pending]: (state, action) => {
            state.isLoading = true;
        },
        [AddProductToCart.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.addProductToCart = action.payload;
        },
        [AddProductToCart.rejected]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.errorMessage = action.payload;
        },
        [GetAllCartItems.pending]: (state, action) => {
            state.isLoading = true;
        },
        [GetAllCartItems.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.getAllCartItems = action.payload;
        },
        [GetAllCartItems.rejected]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.errorMessage = action.payload;
        },
        [DeleteAllItemsCart.pending]: (state, action) => {
            state.isLoading = true;
        },
        [DeleteAllItemsCart.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.deleteAllCartItems = action.payload;
        },
        [DeleteAllItemsCart.rejected]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.errorMessage = action.payload;
        },
        [DeleteOneItemCart.pending]: (state, action) => {
            state.isLoading = true;
        },
        [DeleteOneItemCart.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.deleteOneCartItem = action.payload;
        },
        [DeleteOneItemCart.rejected]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.errorMessage = action.payload;
        },
        [UpdateCartItem.pending]: (state, action) => {
            state.isLoading = true;
        },
        [UpdateCartItem.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.updateCartData = action.payload;
        },
        [UpdateCartItem.rejected]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.errorMessage = action.payload;
        },
        [ApplyCoupon.pending]: (state, action) => {
            state.isLoading = true;
        },
        [ApplyCoupon.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.applyCoupon = action.payload;
        },
        [ApplyCoupon.rejected]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.errorMessage = action.payload;
        },
    }
})

export default CartSlice.reducer